import React, {memo} from 'react';
import Dialog from 'components/Dialog';
import FormikTextField from 'components/inputs/FormikTextField';
import {Grid} from '@mui/material';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import * as yup from 'common/yup';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';

const _validationSchema = yup.object({
   name: yup.string().required(),
});
export type NameFormType = yup.InferType<typeof _validationSchema>;

export interface NameDialogProps {
   title: string;
   label: string;
   type?: 'text' | 'password';
   open?: boolean;
   value?: string;
   validationSchema?: typeof _validationSchema;
   onClose: (nameObj?: NameFormType, callbacks?: FormOnSubmitHelpers<NameFormType>) => void;
}
export const NameDialog = memo(
   ({
      title,
      value,
      onClose: onSubmit,
      label,
      type = 'text',
      open = true,
      validationSchema = _validationSchema,
   }: NameDialogProps) => {
      const onClose = React.useCallback(() => onSubmit(), [onSubmit]);
      return (
         <Dialog open={open} maxWidth="sm" header={title} close={onClose}>
            <Formik
               initialValues={validationSchema.cast({name: value})}
               initialTouched={Boolean(value) ? ['name'] : undefined}
               validationSchema={validationSchema}
               onSubmit={onSubmit}
            >
               <NameForm cancel={onClose} label={label} type={type} />
            </Formik>
         </Dialog>
      );
   }
);

const NameForm = ({
   label,
   cancel,
   type,
}: {
   label: string;
   cancel: () => void;
   type: NameDialogProps['type'];
}) => {
   return (
      <>
         <Grid container spacing={3} justifyContent="center">
            <Grid item sm={11}>
               <FormikTextField autoFocus type={type} name="name" label={label} />
            </Grid>
         </Grid>
         <Grid container spacing={3} justifyContent="center">
            <Grid item>
               <FormFooterButtons cancel={cancel} />
            </Grid>
         </Grid>
      </>
   );
};
